import * as React from "react";
import { QuizGroupSummary } from "./QuizGroupSummary";
import { FruitifyContainer } from "../../../shared-components/Containers";
import { QuizGroupSubmissions } from "./QuizGroupSubmissions";
import { useEffect, useState } from "react";
import { useApiClient } from "../../../api";
import { QuizQuestionLevelAnalysis } from "./QuizQuestionLevelAnalysis";

export const PublishedQuizGroup = ({ quizGroup, setQuizGroup }) => {
  const [submissions, setSubmissions] = useState();

  const ApiClient = useApiClient();

  useEffect(() => {
    if (!quizGroup?.id) return;
    const subscription = ApiClient.quiz.pollQuizGroupSubmissions({
      quizGroup: quizGroup.id,
      pollInterval: 5000,
      onUpdate: (data) => setSubmissions(data),
    });

    return () => subscription.unsubscribe();
  }, [quizGroup]);

  return (
    <FruitifyContainer>
      <QuizGroupSummary quizGroup={quizGroup} setQuizGroup={setQuizGroup} />
      <QuizQuestionLevelAnalysis
        quizGroup={quizGroup}
        sxProps={{ mt: 2, mb: 2 }}
      />
      <QuizGroupSubmissions quizGroup={quizGroup} submissions={submissions} />
    </FruitifyContainer>
  );
};
